
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

interface ChartSkeletonProps {
  title: string;
  description: string;
  height?: number;
  type?: 'bar' | 'pie' | 'line';
}

const ChartSkeleton = React.memo(({ 
  title, 
  description, 
  height = 400, 
  type = 'bar' 
}: ChartSkeletonProps) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <Skeleton className="h-9 w-28" />
      </div>
      
      <Card className="w-full overflow-hidden">
        <CardHeader>
          <CardTitle>{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        <CardContent className="px-2 pb-2">
          <div style={{ height: `${height}px` }} className="w-full">
            {type === 'pie' ? (
              <div className="flex items-center justify-center h-full">
                <Skeleton className="w-64 h-64 rounded-full" />
              </div>
            ) : (
              <div className="flex items-end justify-between h-full px-4 pb-4 space-x-2">
                {Array.from({ length: 8 }).map((_, i) => (
                  <Skeleton 
                    key={i} 
                    className="w-12 rounded-t"
                    style={{ height: `${Math.random() * 0.8 + 0.2}%` }}
                  />
                ))}
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
});

ChartSkeleton.displayName = 'ChartSkeleton';

export default ChartSkeleton;
